"use client";

import {
  MapPinIcon,
  HomeIcon,
  BugAntIcon,
  DocumentDuplicateIcon,
  ShieldExclamationIcon,
} from "@heroicons/react/24/outline";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { getIsUserVerified } from "./actions";
import { useContext, useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styles from "./nav.module.scss";
import { SidebarContext } from "@/providers/sidebar-context";
import { toast } from "react-toastify";
import { Book, ChatHeart, Newspaper } from "react-bootstrap-icons";

const links = [
  {
    name: "Your Profile",
    href: "/profile",
    icon: HomeIcon,
    unverifiedAccess: true,
  },
  {
    name: "Map",
    href: "/map",
    icon: MapPinIcon,
    unverifiedAccess: true,
  },
  {
    name: "Directory",
    href: "/directory",
    icon: DocumentDuplicateIcon,
    unverifiedAccess: true,
  },
  {
    name: "Peatland Glossary",
    href: "/glossary",
    icon: Book,
    unverifiedAccess: false,
  },
  {
    name: "News",
    href: "/news",
    icon: Newspaper,
    unverifiedAccess: false,
  },
  {
    name: "Wish List",
    href: "/wishlist",
    icon: ChatHeart,
    unverifiedAccess: false,
  },
  {
    name: "Feedback or Bug",
    href: "?modal=true",
    icon: BugAntIcon,
    unverifiedAccess: true,
  },
];

export default function NavLinks() {
  const { isCollapsed } = useContext(SidebarContext);
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const pathname = usePathname();

  useEffect(() => {
    async function fetchIsVerified() {
      const isVerified = await getIsUserVerified();
      setIsVerified(isVerified);
      if (!isVerified) {
        toast.warning(
          "Profile verification is pending, some functionality might not be available"
        );
      }
    }
    fetchIsVerified();
  }, []);

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      Your profile verification is pending, check back later.
    </Tooltip>
  );

  return (
    <>
      {links.map(({ name, href, unverifiedAccess, icon: LinkIcon }, i) => {
        return (
          <li className={styles.sidebarItem} key={i}>
            {unverifiedAccess || isVerified ? (
              <></>
            ) : (
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <div
                  className={`${styles.navLinkBlockerIcon} ${
                    isCollapsed ? styles.collapsed : ""
                  }`}
                >
                  <ShieldExclamationIcon className="tw-text-red" />
                </div>
              </OverlayTrigger>
            )}

            <Link
              className={`${styles.sidebarLink} ${
                pathname === href ? styles.sidebarLinkActive : ""
              }`}
              href={href}
              style={{
                pointerEvents: unverifiedAccess || isVerified ? "auto" : "none",
              }}
            >
              <span className={styles.sidebarIcon}>
                <LinkIcon className="tw-w-6" />
              </span>
              <span className={styles.sidebarName}>{name}</span>
            </Link>
          </li>
        );
      })}
    </>
  );
}
